import { Injectable } from '@angular/core'
import { map } from 'rxjs/operators'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { User } from '../models/User'
import { PATH } from '../app.api'
import { Router } from '@angular/router'
import { Observable } from 'rxjs'
import { HelperService } from './helper.service'
import { setEnableCommunication, setEnableCloneInventory, setEnableLegalFundamentation, setLoggedUser } from '../_helpers/LocalStorage'
import { IPublicReportByTokenDto } from '../components/validation-report/dto/public-report-by-token.dto'

@Injectable()
export class AuthenticationService {
	constructor(private http: HttpClient, private router: Router, private helper: HelperService) { }

	private setHeaders(): HttpHeaders {
		return new HttpHeaders({ 'Content-Type': 'application/json' })
	}

	public logoff(): void {
		if (localStorage.getItem('access_token') != null) {
			this.http.post<any>(`${PATH}/auth/logout`, { headers: this.setHeaders() }).subscribe(() => {
				this.helper.setAlreadyConnectedInWebsocket(false)
				if (this.helper.getWebsocket()) {
					this.helper.getWebsocket().disconnect()
				}
				this.router.navigate(['/login'])
				this.helper.clearLocalStorage()
			})
		} else {
			this.router.navigate(['/login'])
		}
	}

	public validateReportToken(token: string, type: string): Observable<IPublicReportByTokenDto> {
		return this.http.get<IPublicReportByTokenDto>(`${PATH}/auth/validate-report-token?token=${token}&type=${type}`, { headers: this.setHeaders().append('skipinterceptor', 'true') })
	}

	public refreshAccess(refresh_token: string): Observable<void> {
		return this.http.post<any>(`${PATH}/auth/refresh`, { refresh_token }, { headers: this.setHeaders().append('skipinterceptor', 'true') }).pipe(
			map(result => {
				if (result && result.access_token) {
					localStorage.setItem('access_token', JSON.stringify(result.access_token.accessToken))
				}
				if (result && result.access_token) {
					localStorage.setItem('refresh_token', JSON.stringify(result.access_token.refreshToken))
				}

				return result
			})
		)
	}

	public login(user: User): Observable<void> {
		return this.http.post<any>(`${PATH}/auth`, JSON.stringify(user), { headers: this.setHeaders() }).pipe(
			map(result => {
				if (result && result.access_token) {
					localStorage.setItem('access_token', JSON.stringify(result.access_token))
					localStorage.setItem('refresh_token', JSON.stringify(result.refresh_token))
					localStorage.setItem('zendesk_token', JSON.stringify(result.zendesk_token))
					setLoggedUser(result.content)

					if (result.content.companies.length !== 0) {
						localStorage.setItem('companyId', result.content.companies[0]._id)
						localStorage.setItem('companyName', result.content.companies[0].social_name)
						setEnableLegalFundamentation(result.content.companies[0].enableLegalFundamentation)
						setEnableCommunication(result.content.companies[0].enableNotifications)
						setEnableCloneInventory(result.content.companies[0].enableCloneInventory)
					}
				}
			})
		)
	}

	public rememberPassword(email: string): Observable<any> {
		return this.http.post<any>(`${PATH}/auth/remember-password`, { email }, { headers: this.setHeaders() })
	}

	public getUserByToken(token: string): Observable<any> {
		return this.http.post<any>(`${PATH}/auth/get-user-by-token/`, { token }, { headers: this.setHeaders() }).pipe(
			map(result => {
				if (result && result.content) {
					return result.content
				}
			})
		)
	}

	public changePassword(token: string, password: string): Observable<any> {
		return this.http.post<any>(`${PATH}/auth/change-password`, { token, password }, { headers: this.setHeaders() })
	}
}
